import React, { useRef } from "react";
import { Item, MoreMenuContainer } from "./style";

const MoreMenu = ({ menu, close }) => {
  const menuRef = useRef();

  if (typeof window !== "undefined") {
    const listener = event => {
      // Do nothing if clicking ref's element or descendent elements
      if (!menuRef.current || menuRef.current.contains(event.target)) {
        return;
      }
      close();
    };

    document.addEventListener("click", listener);
    document.addEventListener("touchstart", listener);
  }
  return (
    <MoreMenuContainer ref={menuRef}>
      {menu.map((item, key) => {
        return (
          <Item
            key={key}
            type={item.type}
            onClick={event => {
              event.stopPropagation();
              item.onClick();
            }}
          >
            <i className={`icon ${item.icon} item-icon`} />
            <div className="item-text">{item.text}</div>
          </Item>
        );
      })}
    </MoreMenuContainer>
  );
};

export default MoreMenu;
